import React, { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import api from '../../services/api';

const ShopAdminPlans = () => {
  const [plans, setPlans] = useState([]);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [plansRes, subscriptionRes] = await Promise.all([
        api.get('/api/shop/plans'),
        api.get('/api/shop/subscription').catch(() => ({ data: { success: false } }))
      ]);
      setPlans(plansRes.data.data);
      if (subscriptionRes.data.success) {
        setSubscription(subscriptionRes.data.data);
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Error fetching plans' });
    } finally {
      setLoading(false);
    }
  };

  const handleSubscribe = async (planId) => {
    if (window.confirm('Are you sure you want to subscribe to this plan? (Payment simulation)')) {
      try {
        await api.post('/api/shop/subscribe', { planId });
        setMessage({ type: 'success', text: 'Subscription activated successfully!' });
        fetchData();
        setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      } catch (error) {
        setMessage({ type: 'error', text: error.response?.data?.message || 'Error subscribing to plan' });
      }
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="loading"><div className="spinner"></div></div>
      </div>
    );
  }

  return (
    <div className="app">
      <Navbar />
      <div className="container">
        <h1 className="page-title">Subscription Plans</h1>

        {message.text && (
          <div className={`alert alert-${message.type === 'error' ? 'error' : 'success'}`}>
            {message.text}
          </div>
        )}

        {subscription && (
          <div className="card">
            <div className="alert alert-info">
              <strong>Current Plan: {subscription.planId?.name}</strong>
              <p>
                Max Offers: {subscription.planId?.maxMainAds} | Remaining: {subscription.remainingMainAdsCount}
              </p>
              <p>
                Poster Ads: {subscription.usedPosterAdsCount || 0}/{subscription.planId?.maxPosterAds ?? subscription.planId?.maxMainAds}
                {' | '}
                Product Offers: {subscription.usedProductAdsCount || 0}/{subscription.planId?.maxProductAds ?? subscription.planId?.maxMainAds}
              </p>
              {subscription.endDate && (
                <p>Expires: {new Date(subscription.endDate).toLocaleDateString()}</p>
              )}
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
          {plans.map(plan => (
            <div key={plan._id} className="card" style={{ border: subscription?.planId?._id === plan._id ? '2px solid #007bff' : '1px solid #ddd' }}>
              <h2 style={{ marginBottom: '15px' }}>{plan.name}</h2>
              <div style={{ fontSize: '32px', fontWeight: 'bold', marginBottom: '20px' }}>
                ₹{plan.price}
              </div>
              <ul style={{ listStyle: 'none', padding: 0, marginBottom: '20px' }}>
                <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                  Max {plan.maxMainAds} active offers
                </li>
                <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                  {plan.maxPosterAds ?? plan.maxMainAds} poster ads
                </li>
                <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                  {plan.maxProductAds ?? plan.maxMainAds} product offers
                </li>
                <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                  {plan.maxProductsPerAd || 1} products per offer
                </li>
                <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                  {plan.maxSubImagesPerMainAd} sub images per ad
                </li>
                <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                  Ad duration: up to {plan.maxAdsDurationDays} days
                </li>
                <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                  Plan validity: {plan.durationDays || 30} days
                </li>
              </ul>
              {subscription?.planId?._id === plan._id ? (
                <button className="btn btn-secondary" disabled>
                  Current Plan
                </button>
              ) : (
                <button
                  className="btn btn-primary"
                  onClick={() => handleSubscribe(plan._id)}
                >
                  Subscribe
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShopAdminPlans;

